<template>
  <l-layout :layout="['xs12']">
    <v-card>
      <v-card-title style="height: 60px">账单详情</v-card-title>
      <v-form ref="billForm">
        <v-layout column class="pa-3">
          <v-flex xs12>
            <l-plate-picker v-model="form.plateNumb" readonly></l-plate-picker>
          </v-flex>
          <v-flex xs12>
            <v-text-field
              label="账单状态"
              prepend-icon="$vuetify.icons.code"
              v-model="form.status"
              readonly
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field
              label="账单金额"
              prepend-icon="mdi-cash-usd"
              v-model="form.paidAmount"
              suffix="元"
              readonly
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field
              label="进场卡口"
              prepend-icon="$vuetify.icons.location"
              v-model="form.entryPortId"
              readonly
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <l-select-datetime
              label="进场时间"
              v-model="form.entryTime"
              readonly
            ></l-select-datetime>
          </v-flex>
          <v-flex xs12>
            <v-text-field
              label="出场卡口"
              prepend-icon="$vuetify.icons.location"
              v-model="form.departurePortId"
              readonly
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <l-select-datetime
              label="出场时间"
              v-model="form.departureTime"
              readonly
            ></l-select-datetime>
          </v-flex>
          <v-layout>
            <v-textarea
              rows="1"
              auto-grow
              v-model="form.description"
              label="账单描述"
              prepend-icon="$vuetify.icons.comment"
              readonly
            >
            </v-textarea>
          </v-layout>
          <v-layout justify-center column>
            <v-btn
              @click="chosePayMethod"
              v-if="needPay"
              class="primary"
              :loading="loading"
              >支付订单</v-btn
            >
            <v-btn
              color="primary"
              v-if="!showDetails"
              @click="showDetails = !showDetails"
              >点击查看账单明细</v-btn
            >
            <v-btn
              color="primary"
              v-if="showDetails"
              @click="showDetails = !showDetails"
              >隐藏账单明细</v-btn
            >
          </v-layout>
          <v-layout v-if="showDetails">
            <v-flex xs12>
              <l-data-table
                :items="form.subBills"
                :headers="header"
                hide-title
              ></l-data-table>
            </v-flex>
          </v-layout>
        </v-layout>
      </v-form>
    </v-card>
    <v-dialog width="350px" v-model="rechargeInfo.activated" persistent>
      <v-layout column justify-center>
        <v-card>
          <v-subheader>钱包充值</v-subheader>
          <v-form ref="rechargeForm" class="pa-3" v-if="!loading">
            <v-layout column>
              <v-flex xs12>
                <v-select
                  :items="rechargeInfo.rechargeItems"
                  item-text="value"
                  item-value="value"
                  v-model="rechargeInfo.rechargeSelect"
                  label="充值金额选择"
                  prepend-icon="mdi-currency-usd"
                ></v-select>
              </v-flex>
              <v-flex xs12 v-if="rechargeInfo.rechargeSelect === '其他'">
                <v-text-field
                  label="请填写充值金额"
                  prepend-icon="mdi-currency-usd"
                  v-model="rechargeInfo.amount"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-form>
          <v-container align-center fill-height v-else>
            <v-layout align-center class="pt-4" column style="height: 200px">
              <v-progress-circular
                :color="'accent'"
                :value="100"
                size="50"
                indeterminate
              ></v-progress-circular>
              <!--<v-btn @click="goTo()">跳转</v-btn>-->
              <span class="pt-3" style="font-size: 20px">正在创建订单...</span>
            </v-layout>
          </v-container>
          <v-card-actions>
            <v-layout justify-center>
              <v-btn color="error" @click="rechargeInfo.activated = false"
                >取消</v-btn
              >
              <v-btn color="primary" @click="recharge" :loading="loading"
                >提交</v-btn
              >
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-layout>
    </v-dialog>
    <v-dialog width="350px" v-model="payDialog" persistent>
      <v-layout column justify-center>
        <v-card class="pa-3">
          <v-subheader>支付方式选择</v-subheader>
          <v-radio-group v-model="payMethod">
            <v-radio
              :disabled="cmp"
              :label="userLeftLabel"
              value="userLeft"
            ></v-radio>
            <v-radio :label="'微信支付'" value="weixin"></v-radio>
            <v-radio
              v-show="cmp"
              :label="'钱包充值'"
              value="recharge"
            ></v-radio>
          </v-radio-group>
          <v-card-actions>
            <v-layout justify-center>
              <v-btn color="error" @click="payDialog = false">取消</v-btn>
              <v-btn color="primary" @click="submit" :loading="loading"
                >确定</v-btn
              >
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-layout>
    </v-dialog>
  </l-layout>
</template>
<script>
import { BILL_STATUS_TEXT } from "@/object";
import lPlatePicker from "../../components/LPlatePicker";
import LDataCard from "@/components/LDataCard";
import wx from "weixin-js-sdk";
let chargingTypeMap = {
  simple: "简单计费",
  period: "周期计费",
};
export default {
  components: {
    lPlatePicker,
    LDataCard,
  },
  data() {
    return {
      loading: false,
      showDetails: false,
      billId: "",
      formData: {},
      needPay: false,
      form: {
        plateNumb: "",
        paidAmount: "",
        entryPortId: "",
        entryPortName: "",
        entryTime: "",
        departurePortId: "",
        departurePortName: "",
        departureTime: "",
        description: "",
        status: "",
        userId: "",
        subBills: [],
      },
      rechargeInfo: {
        amount: "",
        activated: false,
        rechargeItems: [
          { isSelect: false, value: "20" },
          { isSelect: false, value: "50" },
          { isSelect: false, value: "100" },
          { isSelect: false, value: "200" },
          { isSelect: false, value: "其他" },
        ],
        rechargeSelect: "",
      },
      header: [
        {
          text: "驶入卡口",
          value: "entryPortId",
          sortable: false,
          align: "left",
          f: (v) => this.gateTrans(v),
        },
        {
          text: "驶入时间",
          value: "entryTime",
          sortable: false,
          align: "left",
          f: (v) => this.$L.time.stringify(v),
        },
        {
          text: "驶出卡口",
          value: "departurePortId",
          sortable: false,
          align: "left",
          f: (v) => this.gateTrans(v),
        },
        {
          text: "驶出时间",
          value: "departureTime",
          sortable: false,
          align: "left",
          f: (v) => this.$L.time.stringify(v),
        },
        {
          text: "账单金额",
          value: "payableAmount",
          sortable: false,
          align: "left",
        },
      ],
      userInfo: {
        left: "",
      },
      payDialog: false,
      payMethod: "",
    };
  },
  computed: {
    userLeftLabel() {
      return "用户钱包(钱包余额:" + this.userInfo.left / 100 + "元)";
    },
    cmp() {
      return parseInt(this.form.paidAmount) > parseInt(this.userInfo.left);
    },
  },
  created() {
    this.$store.dispatch("login/initControllers");
    if (this.$route.query.billId !== undefined) {
      this.billId = this.$route.query.billId;
      this.getBillInfo();
    } else {
      if (this.$route.query.gateId !== undefined) {
        this.getBillByControllerId(this.$route.query.gateId);
      }
    }
  },
  methods: {
    async getBillByControllerId(controllerId) {
      let res = await this.$store.dispatch(
        "pay/getBillByControllerId",
        controllerId
      );
      // console.log(items)
      if (res.data.status + "" === "200") {
        this.formData = res.data.data;
        this.init();
      } else {
        this.$L.alert("error", {
          message: "获取账单失败，原因：" + res.data.msg,
        });
      }
      /*      this.formData = res
      this.init()*/
    },
    async getBillInfo() {
      let { items, amount } = await this.$store.dispatch("pay/getBillList", {
        pagination: { page: 1, rowsPerPage: 10 },
        search: { key: "id", value: this.billId },
      });
      // console.log(items)
      this.formData = items[0];
      this.init();
    },
    gateTrans(v) {
      if (v == "") {
        return;
      } else {
        let controllerList = this.$store.state.parkingLot.controllerList;
        //console.log(controllerList)
        // console.log(v)
        for (let i = 0; i < controllerList.length; i++) {
          if (controllerList[i].id === v) {
            return controllerList[i].name;
          }
        }
        return "";
      }
    },
    init() {
      // console.log(this.formData)
      this.form.userId = this.formData.userId;
      this.form.plateNumb = this.formData.plateNumb;
      this.form.paidAmount = this.formData.paidAmount;
      this.form.entryPortId = this.gateTrans(this.formData.entryPortId);
      this.form.entryTime = this.$L.time
        .stringify(this.formData.entryTime)
        .substr(0, 16);
      this.form.departurePortId = this.gateTrans(this.formData.departurePortId);

      this.form.departureTime = this.$L.time.stringify(
        this.formData.departureTime
      );
      this.form.description = this.formData.description;
      this.form.status = BILL_STATUS_TEXT[this.formData.status];
      this.form.subBills = this.formData.subBills;
      if (
        this.formData.status === "settled_unpaid" ||
        this.formData.status === "settled_additional"
      ) {
        this.needPay = true;
      } else {
        this.needPay = false;
      }
    },
    async getSubBills({ pagination, sortStack, filter }) {
      return { items: this.form.subBills, amount: this.form.subBills.length };
    },
    async createOrder() {
      let p = await this.$store.dispatch("login/getSelfInfo");
      let params = {
        userId: p.id,
        plateNum: this.form.plateNumb,
        billId: this.billId,
      };
      this.loading = true;
      let res = await this.$store.dispatch("pay/createOrder", params);
      this.loading = false;
      if (res.data.status + "" === "200") {
        // alert('创建订单成功')
        this.$L.alert("success", { message: "创建订单成功" });
        // let data = JSON.parse(res.data.data)
        // console.log(data.package)
        this.wexinPay(JSON.parse(res.data.data));
      } else {
        this.$L.alert("error", {
          message: "创建订单失败，原因:" + res.data.msg,
        });
      }
    },
    // 调用微信JS api 支付
    /*    weixinPay: function (data) {
      var vm = this
      if (typeof WeixinJSBridge === 'undefined') {
        if (document.addEventListener) {
          document.addEventListener('WeixinJSBridgeReady', vm.onBridgeReady(data), false)
        }
        else if (document.attachEvent) {
          document.attachEvent('WeixinJSBridgeReady', vm.onBridgeReady(data))
          document.attachEvent('onWeixinJSBridgeReady', vm.onBridgeReady(data))
        }
      }
      else {
        vm.onBridgeReady(data)
      }
    },
    onBridgeReady: function (data) {
      var vm = this
      WeixinJSBridge.invoke(
        'getBrandWCPayRequest',
        {
          appId: 'wxfd33224488b5cf00', // 公众号名称，由商户传入
          timeStamp: data.timestamp, // 时间戳，自1970年以来的秒数
          nonceStr: data.nonce_str, // 随机串
          package: data.package, // 订单详情扩展字符串
          signType: data.signType, // 微信签名方式：
          paySign: data.paySign, // 微信签名
        },
        function (res) {
          if (res.err_msg == 'get_brand_wcpay_request:ok') {
            // ...
          }
          else {
            alert('支付失败！')
          }
        }
      )
    } */
    wexinPay(data) {
      let appId = "wxfd33224488b5cf00";
      let timestamp = data.timeStamp;
      let nonceStr = data.nonceStr;
      let signature = data.signature;
      let packages = data.package;
      let paySign = data.paySign;
      let _this = this;
      /*      alert(timestamp)
      alert(packages) */
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: appId, // 必填，公众号的唯一标识
        timestamp: timestamp, // 必填，生成签名的时间戳
        nonceStr: nonceStr, // 必填，生成签名的随机串
        signature: signature, // 必填，签名，见附录1
        jsApiList: ["chooseWXPay"], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
      });
      wx.ready(function () {
        wx.chooseWXPay({
          timestamp: timestamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
          nonceStr: nonceStr, // 支付签名随机串，不长于 32 位
          package: packages, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=***）
          signType: "MD5", // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
          paySign: paySign, // 支付签名
          success: function (res) {
            // 支付成功后的回调函数
            // this.$L.alert('success', {message: '支付成功'})
            alert("支付成功");
            _this.getBillInfo();
          },
          fail: function (res) {
            // this.$L.alert('error', {message: '支付失败'})
            alert("支付失败");
            _this.getBillInfo();
          },
        });
      });
      wx.error(function (res) {
        // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
        alert("config信息验证失败");
      });
    },
    async getUserDetail() {
      let p = await this.$store.dispatch("login/getSelfInfo");
      let params = {
        searchParam: {
          userId: {
            index: "1",
            order: "DESC",
            operators: [
              {
                keyword: p.id,
                operator: "EQ",
                matchType: "NONE",
              },
            ],
          },
        },
      };
      try {
        let res = await this.$store.dispatch("pay/getUserInfo", params);
        if (res.data.status + "" === "200") {
          if (res.data.data.content.length === 0) {
            this.$L.alert("error", { message: "未查询到该用户" });
            return;
          } else {
            this.userInfo.left = res.data.data.content[0].balance;
          }
        }
      } catch (e) {
        console.log(e);
      }
    },
    async createOrderByLeft() {
      let p = await this.$store.dispatch("login/getSelfInfo");
      let params = {
        userId: p.id,
        plateNum: this.form.plateNumb,
        billId: this.billId,
      };
      this.loading = true;
      let res = await this.$store.dispatch("pay/createOrderByLeft", params);
      this.loading = false;
      if (res.data.status + "" === "200") {
        this.payDialog = false;
        this.$L.alert("success", { message: "支付成功" });
        this.getBillInfo();
      } else {
        this.$L.alert("error", {
          message: "支付失败，错误信息为" + res.data.msg,
        });
      }
    },
    async recharge() {
      if (!this.$refs.rechargeForm.validate()) {
        this.$L.alert("error", { message: "表单数据有误" });
        return;
      }
      if (this.rechargeInfo.rechargeSelect !== "其他") {
        this.rechargeInfo.amount = this.rechargeInfo.rechargeSelect;
      }
      let p = await this.$store.dispatch("login/getSelfInfo");
      let params = {
        amount: this.rechargeInfo.amount,
        userId: p.id,
      };
      this.loading = true;
      let res = await this.$store.dispatch("pay/recharge", params);
      this.loading = false;
      if (res.data.status + "" === "200") {
        let params = JSON.parse(res.data.data);
        this.wexinPay(params);
      } else {
        this.$L.alert("error", { message: "创建订单失败" });
      }
    },
    async chosePayMethod() {
      await this.getUserDetail();
      this.payDialog = true;
    },
    submit() {
      switch (this.payMethod) {
        case "userLeft":
          return this.createOrderByLeft();
        case "weixin":
          return this.createOrder();
        case "recarge":
          this.payDialog = false;
          this.rechargeInfo.activated = true;
      }
    },
  },
};
</script>
